/** Grey shimmer shown in place of a photo until it has loaded (live photo thumbnails, ecam-v2 photos). */
export const loadingShimmerSx = {
    bgcolor: '#e0e0e0',
    backgroundImage: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
    backgroundSize: '200px 100%',
    animation: 'shimmer 1.5s infinite',
    '@keyframes shimmer': {
        '0%': { backgroundPosition: '-200px 0' },
        '100%': { backgroundPosition: '200px 0' },
    },
} as const;
